module.exports = __webpack_public_path__ + "img/cover-fishing-bg.b37c63af.jpg";